import { PlusIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '../../core/hooks/useTranslation'

interface AddButtonProps {
    onClick: () => void
    label?: string
    className?: string
    showLabel?: boolean
    title?: string
    variant?: 'icon-only' | 'with-label'
    disabled?: boolean
}

export default function AddButton({
    onClick,
    label,
    className = '',
    showLabel = false,
    title,
    variant = 'icon-only',
    disabled = false
}: AddButtonProps) {
    const { t, isRTL } = useTranslation()
    const displayLabel = label || t('create')
    const displayTitle = title || displayLabel

    const isIconOnly = variant === 'icon-only' || (!showLabel && variant !== 'with-label')

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`bg-[#1E293B] text-white hover:bg-[#0F172A] active:bg-[#020617] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center rounded-xl transition-colors ${
                isIconOnly 
                    ? 'py-3 px-3' 
                    : 'py-2 px-4'
            } ${className}`}
            title={displayTitle}
        >
            <PlusIcon className={`${isIconOnly ? 'w-5 h-5' : 'w-4 h-4'}`} />
            {!isIconOnly && (
                <span className={isRTL ? 'mr-1' : 'ml-1'}>
                    {displayLabel}
                </span>
            )}
        </button>
    )
}

